import { render, staticRenderFns } from "./RegularMedia.vue?vue&type=template&id=20ba1d7a&scoped=true&name=regular-media&"
import script from "./RegularMedia.vue?vue&type=script&lang=js&"
export * from "./RegularMedia.vue?vue&type=script&lang=js&"
import style0 from "./RegularMedia.vue?vue&type=style&index=0&id=20ba1d7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ba1d7a",
  null
  
)

export default component.exports